import { render, staticRenderFns } from "./chip-large.vue?vue&type=template&id=08b78d3d&scoped=true&"
import script from "./chip-large.vue?vue&type=script&lang=js&"
export * from "./chip-large.vue?vue&type=script&lang=js&"
import style0 from "./chip-large.vue?vue&type=style&index=0&id=08b78d3d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b78d3d",
  null
  
)

export default component.exports